import type { CatalogComponentProperties } from '@/domain/catalog/common';
import type { CupSystem } from '@/domain/catalog/cup';
import type { HeadSize } from '@/domain/catalog/head';

export enum LinerSize {
    // noinspection JSUnusedGlobalSymbols
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D',
    E = 'E',
    F = 'F',
    G = 'G',
    H = 'H',
    I = 'I',
    J = 'J',
}

export enum LinerType {
    // noinspection JSUnusedGlobalSymbols
    NEUTRAL = 'neutral',
    HIGHWALL = 'highwall',
    TEN_DEG = '10-deg',
    DUAL_MOBILITY = 'dual_mobility',
}

export const linerSizes = Object.values(LinerSize);
export type LinerSizeValue = (typeof linerSizes)[number];

export function isLinerSize(value: string): value is LinerSizeValue {
    return linerSizes.includes(value as LinerSizeValue);
}

export const linerTypes = Object.values(LinerType);
export type LinerTypeValue = (typeof linerTypes)[number];

export function isLinerType(value: string): value is LinerTypeValue {
    return linerTypes.includes(value as LinerTypeValue);
}

/** Properties of a type of liner, independent of its use in any particular case  */
export type CatalogLiner = CatalogComponentProperties & {
    /** The cup-system the liner belongs to e.g. g7 */
    system: CupSystem;

    /** The size of the liner A, B, C... */
    size: LinerSizeValue;

    /** The type of the liner */
    type: LinerTypeValue;

    /** The recommended head-size */
    headSize: HeadSize;
};
